import React from 'react';
import styles from './JuryCategoryBadge.module.scss';
import { mergeClassNames } from '@core/shared';

/**
 * Shared badge/pill component for Jury categories.
 * Used in both project cards (static) and filters (interactive).
 */
const JuryCategoryBadge = ({
    label,
    color,
    isSelected = false,
    size = 'md',
    onClick,
    className,
    component: Component = 'span',
    ...props
}) => {
    const isInteractive = !!onClick;

    const classes = mergeClassNames(
        styles.Badge,
        styles[`Size${size.charAt(0).toUpperCase() + size.slice(1)}`],
        isInteractive ? styles.Interactive : '',
        isSelected ? styles.Selected : styles.Unselected,
        className
    );

    const style =
        isSelected || !isInteractive ? { backgroundColor: color, borderColor: color } : { borderColor: color };

    // If interactive, we force a button if no component was specified
    const Tag = isInteractive && Component === 'span' ? 'button' : Component;

    return (
        <Tag
            {...(Tag === 'button' ? { type: 'button' } : {})}
            className={classes}
            style={style}
            onClick={onClick}
            {...(isInteractive ? { 'aria-pressed': isSelected } : {})}
            {...props}
        >
            {label}
        </Tag>
    );
};

export default JuryCategoryBadge;
